import React from 'react';
import Loading from '~/Components/Loading';
import FormValoresComissao from './FormValoresComissao';
import GridSequencias from './GridSequencias';
import GridFaixas from './GridFaixas';
import CopiarComissao from './CopiarComissao';
import GridCaptacao from './GridCaptacao';
import GridProspecto from './GridProspecto';
import GridRetida from './GridRetida';
import GridComFixa from './GridComFixa';
import GridChequeBonus from './GridChequeBonus';
import GridTipoOutro from './GridTipoOutro';

const TabComissoes = ({ codigoFamilia, dados, dadosGerais, comFixa, familias, permissoes, onRecarregar }) => {
  if (dados == null) return <Loading />;

  return (
    <div>
      <FormValoresComissao
        codigoFamilia={codigoFamilia}
        dados={dadosGerais}
        permissoes={permissoes}
      />
      {permissoes.comissao && (
        <>
          <GridFaixas
            codigoFamilia={codigoFamilia}
            faixas={dados.faixas != null ? dados.faixas : []}
            onRecarregar={onRecarregar}
          />
          <GridSequencias
            codigoFamilia={codigoFamilia}
            sequencias={dados.sequencias != null ? dados.sequencias : []}
            onRecarregar={onRecarregar}
          />
          <CopiarComissao
            codigoFamilia={codigoFamilia}
            familias={familias}
            onRecarregar={onRecarregar}
          />
          <GridRetida
            codigoFamilia={codigoFamilia}
            retidas={dados.retidas != null ? dados.retidas : []}
            onRecarregar={onRecarregar}
          />
          <GridChequeBonus
            codigoFamilia={codigoFamilia}
            chequeBonus={dados.cheque_bonus != null ? dados.cheque_bonus : []}
            onRecarregar={onRecarregar}
          />
          <GridTipoOutro
            codigoFamilia={codigoFamilia}
            onRecarregar={onRecarregar}
          />
        </>
      )}

      {permissoes.captacao && (
        <GridCaptacao
          codigoFamilia={codigoFamilia}
          captacao={dados.captacao != null ? dados.captacao : []}
          onRecarregar={onRecarregar}
        />
      )}

      {permissoes.comissao && (
        <GridProspecto
          codigoFamilia={codigoFamilia}
          prospectos={dados.prospectos != null ? dados.prospectos : []}
          onRecarregar={onRecarregar}
        />
      )}

      <GridComFixa
        codigoFamilia={codigoFamilia}
        comFixa={comFixa}
        onRecarregar={onRecarregar}
      />
    </div>
  );
};

export default TabComissoes;
